import { render, staticRenderFns } from "./CompetitionListEntryCompetitionLayout.vue?vue&type=template&id=03182442&scoped=true&"
import script from "./CompetitionListEntryCompetitionLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListEntryCompetitionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03182442",
  null
  
)

export default component.exports